import { GeoJSON } from 'echarts/types/src/coord/geo/geoTypes';

import { defaultDashboardWidgets } from '@/bundles/Settings/helpers/defaultLayout';
import { OpexDisplayEnum } from '@/bundles/Members/enums';
import { Nullable } from '@/utils/types';
import { IMemberVisualizationSettings, IAiKeyListItem, IRecordPermission } from '@/bundles/Members/interfaces/IMemberSettings';

export const getInitialState = () => ({
  settings_key: 0,
  focus_area: null as Nullable<GeoJSON>,
  permission: {
    documents: {
      share: false,
      share_per_document: false,
    },
    company: {
      share: false,
      share_notes: false,
    },
    contact: {
      share: false,
      share_notes: false,
    },
    contacts: {
      share: false,
      share_notes: false,
    },
    properties: {
      share: false,
      share_notes: false,
    },
    availabilities: {
      share: false,
      share_notes: false,
    },
    occupiers: {
      share: false,
      share_notes: false,
      share_schedule: false,
    },
    feedback: {
      display: true,
    },
  },
  rowsPerPage: 25,
  device_tokens: [],
  layoutSettings: [
    {
      page: 'dashboard',
      widgets: defaultDashboardWidgets,
      isFetched: false,
    }
  ],
  userNotificationsSettings: {
    email: false,
    property_true_owner_change: false,
  },
  opexDisplay: OpexDisplayEnum.opex,
  visualizationSettings: null as Nullable<IMemberVisualizationSettings>,
  aiKeys: [] as IAiKeyListItem[],
  recordPermissions: [] as IRecordPermission[],
  custom_fields: {
    comparable: null,
    company: null,
    contact: null,
    deal: null,
    property: null,
    availability: null,
    pipeline: null,
    occupier: null,
    eblast: null,
    marketingCampaign: null,
    signList: null,
    request: null,
    pressrelease: null,
    project: null,
    requirement: null,
  },
});
